






















import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import { CartItemDTO } from '@/api';
import { getAssetUrl } from '@/utils';

import { shoppingModule } from '@/store';

@Component({
  name: 'shopping-item',
})
export default class CatalogFilter extends Vue {
  @Prop(Object) item!: CartItemDTO;

  selected = false;

  itemPicUrl = (path: string) => getAssetUrl(path);

  deleteItem() {
    if (this.item && this.item.id != null) {
      shoppingModule.deleteShoppingItems([this.item.id]);
    }
  }
}
